// client/src/components/MerchantNavbar.js
import React from 'react';
import { NavLink } from 'react-router-dom';
import { FaHome, FaFileInvoiceDollar, FaSlidersH, FaCamera, FaUser } from 'react-icons/fa';
import { SidebarBrand } from '../shared/BrandLogo';
import '../CSS/Navbar.css';

const MerchantNavbar = () => {
  return (
    <div className="sidebar-container">
      <SidebarBrand label="Espace commerçant" />
      <div className="sidebar-item">
        <NavLink
          to="/merchant-dashboard"
          end
          className={({ isActive }) => `sidebar-link${isActive ? ' active' : ''}`}
        >
          <FaHome size={20} />
          <span>Accueil</span>
        </NavLink>
      </div>

      <div className="sidebar-item">
        <NavLink
          to="/merchantinvoices"
          className={({ isActive }) => `sidebar-link${isActive ? ' active' : ''}`}
        >
          <FaFileInvoiceDollar size={20} />
          <span>Documents</span>
        </NavLink>
      </div>

      <div className="sidebar-item">
        <NavLink
          to="/merchantcamera"
          className={({ isActive }) => `sidebar-link${isActive ? ' active' : ''}`}
        >
          <FaCamera size={20} />
          <span>Caméra</span>
        </NavLink>
      </div>

      <div className="sidebar-item">
        <NavLink
          to="/merchantgestion"
          className={({ isActive }) => `sidebar-link${isActive ? ' active' : ''}`}
        >
          <FaSlidersH size={20} />
          <span>Gestion</span>
        </NavLink>
      </div>

      <div className="sidebar-item">
        <NavLink
          to="/merchantsettings"
          className={({ isActive }) => `sidebar-link${isActive ? ' active' : ''}`}
        >
          <FaUser size={20} />
          <span>Profil</span>
        </NavLink>
      </div>
    </div>
  );
};

export default MerchantNavbar;
